import { connect, Dispatch } from 'react-redux';
import ProfileContent from './ProfileContent';
import { ProfileActions } from '../../../../store/action/profileActions';
import { profileOptionSelect } from '../../../../store/action';
import { RootState } from '../../../../store/reducers/index';

const mapStateToProps = (state: RootState) => {
    const { profileReducer } = state;
    const { segment, role, region } = profileReducer;

    return {
        segment,
        role,
        region
    };
};

const mapDispatchToProps = (dispatch: Dispatch<ProfileActions>) => {
    return {
        profileOptionSelect(option: string, id: string): void {
            dispatch(profileOptionSelect(option, id));
        }
    };
};

const ProfileContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ProfileContent);

export default ProfileContainer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/profile/ProfileContainer.tsx